import script from "./order-apply.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-apply.vue?vue&type=script&setup=true&lang=ts"

import "./order-apply.vue?vue&type=style&index=0&id=c9e68b5a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9e68b5a"]])

export default __exports__